
export const shared = {
    flowId: '', // 当新建的时候没有 flowId，但只要用户触发了一次，则保存接口会返回对应本次提报的 flowId，需要保存下来，在后续保存/提交中需要作为参数传递。
    currentSkuInfo: null, // 具体sku详情信息，主要包含基础信息，还有是否失效
    allCityList: [],
    allSalesCity: {}, // 所有经营城市列表，也会在各个步骤被使用来做城市信息的提取。
    allExtraProps: {}, // 所有扩展属性列表，用来在各个地方回显或提取扩展属性信息（且后端不关心各个扩展属性在哪里以及如何使用，故需要前端维护并在对应的模块中实现对应渲染逻辑）
    allExtAttrsList: [], // 当前分类下的扩展属性列表
    dnaAttrs: [], // DNA属性
    newAddCityList: [], // 新提报城市
    categoryId: '', // 管理类目id
    bgCategoryId: '', // 后台类目id
    existedCityIds: [], // 已有SKU的城市id
    stepChangeType: 'next', // 当前步骤切换是上一步 pre，还是下一步next
    categoryTreeData: [], // 管理类目树所有数据
    bgCategoryTreeData: [], // 后台类目树所有数据
    rejectedCanNotEditAttrs: {}, // 驳回重新发起，不可编辑的字段
    categoryConfig: {
        flowSpec: {
            contentSectionRequired: 0, // 0不展示 1选填 2必填
            supplierManufactureRequired: 1, // 生产商是否必填 1非必填 2必填
            licenseValidPeriodRule: [], // 资质有效期规则
        },
    },
    similarCspuInfo: {}, // 相似的cspu信息
    allAreaCityList: [], // 区域城市列表，用于基盘城市选择器
};
export const createNewToken = 'createNew';
export const createInfoToken = 'createInfo';
export const productBaseInfoToken = 'productBaseInfo';
export const citySalesInfoToken = 'citySalesInfo';
export const supplierInfoToken = 'supplierInfo';
export const operateInfoToken = 'operateInfo';

export const compsInfo = {
    [createInfoToken]: {
        compId: createInfoToken, label: '提报信息', status: 'process', index: 1,
    },
    [productBaseInfoToken]: {
        compId: productBaseInfoToken, label: '基本信息', status: 'process', index: 2,
    },
    [citySalesInfoToken]: {
        compId: citySalesInfoToken, label: '城市经营信息', status: 'process', index: 3,
    },
    [supplierInfoToken]: {
        compId: supplierInfoToken, label: '资质信息', status: 'process', index: 4,
    },
    [operateInfoToken]: {
        compId: operateInfoToken, label: '内容信息', status: 'process', index: 5,
    },
};

export function getCityInfo(cityIds) {
    if (!Array.isArray(cityIds)) cityIds = [cityIds];
    const result = Object.values(shared.allSalesCity).filter((item) => cityIds.includes(item.value));
    return result.length === 1 ? result[0] : result;
}

export function updateSharedState(prop, value) {
    shared[prop] = value;
}
